/*
 * @创建人: 但志强
 * @修改人: 但志强
 * @描述: 导出word excel 公共方法
 * @创建时间: 2019-08-27 11:11:45
 * @修改时间: 2019-09-18 17:26:55
 */
import { Injectable } from '@angular/core';
import { SwHttpClientService } from '../sw-http-client.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SwExportService {

  constructor(private http:SwHttpClientService) { }

  fileAPI = environment.fileWebAPI
  /**
   * 导出Excel get请求服务
   * @param url 请求路径\
   * @param fileName 文件名称 （xx.xls | xx.xlsx）
   */
  getExportExcel(url,fileName:string){
    this.http.GetExport(url).subscribe(data=>{
        this.downloadExcel(data.body,fileName)
    })
  }

  /**
   * 导出word get请求服务
   * @param url 请求路径
   * @param fileName 文件名称 （xx.doc | xx.docx）
   */
  getExportWord(url,fileName){
    this.http.GetExport(url).subscribe(data=>{
      this.downloadWord(data.body,fileName)
    })
  }

  /**
   * 导出Excel post请求服务
   * @param url 请求路径
   * @param params 请求参数
   * @param fileName 文件名称 （xx.xls | xx.xlsx）
   */
  PostExportExcel(url,params,fileName){
    this.http.PostExport(url,params).subscribe(data=>{
      this.downloadExcel(data.body,fileName)
    })
  }

  GetExportExcel(url,fileName){
    this.http.GetExport(url).subscribe(data=>{
      this.downloadExcel(data.body,fileName)
    })
  }

  /**
   * 导出wrod get请求服务
   * @param url 请求路径
   * @param params 请求参数
   * @param fileName 文件名称 （xx.doc | xx.docx）
   */
  PostExportWord(url, params, fileName) {
    this.http.PostExport(url, params).subscribe(data => {
      this.downloadWord(data.body, fileName)
    })
  }
  

  /**
   * 导出zip post请求服务
   * @param url 请求路径
   * @param params 请求参数
   * @param fileName 文件名称 （xx.doc | xx.docx）
   */
  PostExportZip(url, params, fileName) {
    this.http.PostExport(url, params).subscribe(data => {
      this.downloadZip(data.body, fileName)
    })
  }

  /**
   * 将请求返回的数据转化为excel文件并下载下来的方法
   * @param fileBits 文件
   * @param fileName 文件名称 （xx.xls | xx.xlsx）
   */
  downloadExcel(fileBits,fileName) {
    /* 解决方法,使用 a链接下载,自己取文件名 */
    let elelink = document.createElement('a')
    elelink.download = fileName  //下载文件的文件名
    elelink.style.display = 'none'
    let file = new File([fileBits], null, { type: "application/vnd.ms-excel" })
    elelink.href = URL.createObjectURL(file)  //创建一个指向参数对象的URL
    document.body.appendChild(elelink)  //将创建的a标签设置为不可见,通过a标签链接进行下载,之后将a标签移除
    elelink.click()
    document.body.removeChild(elelink)
    URL.revokeObjectURL(URL.createObjectURL(file));  //不再需要已经创建的对象URL时,需要释放这个地址
  }


  /**
   * 将请求返回的数据转化为Word文件并下载下来的方法
   * @param fileBits 文件
   * @param fileName 文件名称 （xx.xls | xx.xlsx）
   */
  downloadWord(fileBits,fileName) {
    /* 解决方法,使用 a链接下载,自己取文件名 */
    let elelink = document.createElement('a')
    elelink.download = fileName  //下载文件的文件名
    elelink.style.display = 'none'
    let file = new File([fileBits], null, { type: "application/x-msdownload" })
    elelink.href = URL.createObjectURL(file)  //创建一个指向参数对象的URL
    document.body.appendChild(elelink)  //将创建的a标签设置为不可见,通过a标签链接进行下载,之后将a标签移除
    elelink.click()
    document.body.removeChild(elelink)
    URL.revokeObjectURL(URL.createObjectURL(file));  //不再需要已经创建的对象URL时,需要释放这个地址
  }

  /**
   * 将请求返回的数据转化为excel文件并下载下来的方法
   * @param fileBits 文件
   * @param fileName 文件名称 （xx.xls | xx.xlsx）
   */
  downloadZip(fileBits,fileName) {
    /* 解决方法,使用 a链接下载,自己取文件名 */
    let elelink = document.createElement('a')
    elelink.download = fileName  //下载文件的文件名
    elelink.style.display = 'none'
    let file = new File([fileBits], null, { type: "application/zip" })
    elelink.href = URL.createObjectURL(file)  //创建一个指向参数对象的URL
    document.body.appendChild(elelink)  //将创建的a标签设置为不可见,通过a标签链接进行下载,之后将a标签移除
    elelink.click()
    document.body.removeChild(elelink)
    URL.revokeObjectURL(URL.createObjectURL(file));  //不再需要已经创建的对象URL时,需要释放这个地址
  }

}
